module.exports = __webpack_public_path__ + "static/media/goblins_level_finished.d19e2d74.svg";